import { useContext, useMemo } from "react";
import { GoFlyerAdminContext } from "../contextApi/context";
import { getAuthToken } from "../utils/authTokenStorage";

export type AuthHeadersRequestOptions = {
  headers: {
    Authorization: string;
  };
};

export const resolveAuthToken = (user?: {
  jwtToken?: string;
  token?: string;
}): string | undefined => {
  const fromUser = user?.jwtToken ?? user?.token;
  if (fromUser) {
    return fromUser;
  }

  return getAuthToken() ?? undefined;
};

export const useAuthHeaders = (): AuthHeadersRequestOptions => {
  const { state } = useContext(GoFlyerAdminContext);
  const token = useMemo(
    () => resolveAuthToken(state.user) ?? "",
    [state.user?.jwtToken, state.user?.token],
  );

  return useMemo(
    () => ({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
    [token],
  );
};

export const hasAuthToken = (user?: {
  jwtToken?: string;
  token?: string;
}): boolean => Boolean(resolveAuthToken(user));
